import React, { useEffect, useState } from "react";
import { Box, Drawer, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import AttributesExpansion from "../../components/Attributes/AttributesExpansion";
import { PriceExpander } from "../PriceExpander";
import { Button } from "../../components/Button";
import { BsTrashFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import content from "../../content";
import { mapCategoryToAttribute } from "../../components/Attributes/AttributesDrawer";
import {useDispatch, useSelector} from "react-redux";
import {
    getActiveCategory,
    getAttributesByCategory,
    getCurrentProject, getExpanded,
} from "../../reducers/project/selectors";
import AttrubuteInfo from "../../components/Attributes/AttrubuteInfo";
import {Category} from "../../reducers/project";
import CustomExpanders from "../../components/Attributes/CustomExpanders";
import {ProjectActions} from "../../reducers/project/actionsNames";

function MenuDrawerMobile({ open, onClose }: IMenuDrawerMobile) {
  const activeCategory = useSelector(getActiveCategory);
  const [attribute, setAttribute] = useState(null);
  const [openDrawer, setOpen] = useState(false);

  const expanded = useSelector(getExpanded)

  const project = useSelector(getCurrentProject);
  const attr = useSelector(getAttributesByCategory(activeCategory));

  const dispatch = useDispatch();

  const setExpanded = (expanded) => {
      dispatch({type: ProjectActions.SetExpanded, expanded})
  }

  const toggleExpand = (name: string) => {
    setExpanded(name);
  };

  const toggleNext = () => {
    setExpanded(
      activeCategory[activeCategory.indexOf(expanded as any) + 1] || expanded
    );
  };

  useEffect(() => {
    setExpanded(activeCategory[0]);
  }, [activeCategory]);

  return (
    <Drawer
      PaperProps={{
        style: { width: "80%" },
      }}
      ModalProps={{
        style: {
          zIndex: 40001
        }
      }}
      anchor={"right"}
      open={open}
      onClose={onClose}
    >
      <div
        style={{
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "center",
          display: "flex",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <Close />
        </IconButton>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflowX: "hidden",
        }}
      >
          {activeCategory.includes(Category.Custom) && <CustomExpanders expanded={expanded} toggleExpand={toggleExpand}/>}
        {activeCategory.filter(active => (attr as any).find(at => at.category === active && !at.disabled && at.category !== Category.Jamb)).map((active, i) => (
          <AttributesExpansion
              key={'attrExp' + i}
            toggleNext={toggleNext}
            expanded={expanded === active}
            expandedName={active}
            toggleExpand={toggleExpand}
            multi={activeCategory.length > 1}
            attr={attr.filter((a) => a.category === active)}
            name={mapCategoryToAttribute(active)}
            setOpenInfo={(a: any) => {
              setAttribute(a);
              setOpen(true);
            }}
          />
        ))}
      </div>
      <AttrubuteInfo
        attribute={attribute}
        open={openDrawer}
        onClose={() => setOpen(false)}
      />
    </Drawer>
  );
}

export interface IMenuDrawerMobile {
  open: boolean;
  onClose: () => void;
}

export default MenuDrawerMobile;
